/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

const IconTwitter = () => (
  <svg version="1.1" id="twitter" xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 400 400">
    <path style={{ fill: '#A0A0A0' }} d="M125.7,362.6c150.9,0,233.5-125.2,233.5-233.5c0-3.5,0-7-0.2-10.6c16-11.5,29.9-26.1,41-42.6c-14.7,6.6-30.6,10.9-47.2,13c17-10.1,29.9-26.3,36.2-45.5c-15.8,9.4-33.5,16.2-52.2,19.8c-15-16-36.3-25.9-59.9-25.9c-45.3,0-82.1,36.8-82.1,82.1c0,6.4,0.8,12.6,2.1,18.7C128.7,134.8,68.2,102,27.7,52.4c-7,12.2-11,26.3-11,41.3c0,28.5,14.6,53.6,36.5,68.3c-13.4-0.5-26.1-4.2-37.1-10.2c0,0.3,0,0.6,0,1.1c0,39.7,28.3,73,65.8,80.5c-6.9,1.9-14.1,2.9-21.6,2.9c-5.3,0-10.4-0.5-15.4-1.4c10.4,32.7,40.8,56.3,76.7,57c-28.2,22.1-63.5,35.2-102,35.2c-6.6,0-13.1-0.3-19.5-1.1C36.2,349,79.4,362.6,125.7,362.6" />
  </svg>
);
IconTwitter.propTypes = {};

export default IconTwitter;
